//@ts-nocheck
import React from 'react'

import {
  Body,
  COLORS,
  FlexCol,
  FlexGrid,
  FlexRow,
  Layout,
} from 'ethos-design-system'
import PropTypes from 'prop-types'

import Markdown from '../global/Markdown'
import styles from './ThreeBoxes.module.scss'

export const ThreeBoxes = ({ moduleData }) => {
  const { heading, columns } = moduleData

  return (
    <div className="relative">
      <div className={styles.background} />
      <Layout.HorizontallyPaddedContainer>
        <FlexGrid className={styles.container}>
          <FlexRow className={styles.heading}>{heading}</FlexRow>
          <FlexRow>
            <FlexGrid>
              <FlexRow className={styles.columnsRow}>
                {columns.map((columnData) => {
                  const { columnHeading, columnContent } = columnData
                  return (
                    <FlexCol
                      className={styles.columnContainer}
                      key={`column_${columnHeading}_${columnContent}`}
                    >
                      <div className={styles.columnHeading}>
                        {columnHeading}
                      </div>
                      <div className={styles.columnContent}>
                        <Markdown input={columnContent} />
                      </div>
                    </FlexCol>
                  )
                })}
              </FlexRow>
            </FlexGrid>
          </FlexRow>
        </FlexGrid>
      </Layout.HorizontallyPaddedContainer>
    </div>
  )
}

ThreeBoxes.propTypes = {
  moduleData: PropTypes.shape({
    heading: PropTypes.string.isRequired,
    columns: PropTypes.arrayOf(
      PropTypes.shape({
        columnHeading: PropTypes.number.isRequired,
        columnContent: PropTypes.string.isRequired,
      })
    ),
  }).isRequired,
}

export default ThreeBoxes
